export { PaymentQR } from './PaymentQR';
